//import LoginPage from "./Pages/Login/Login";
//import LoginOrRegisterPage from "./Pages/LoginOrRegister/LoginOrRegister";
import React from "react";
import CategoryProductList from "../../Mobile/Pages/PackageList/Components/CategoryProductList";

const Routes = {
  frontpage: {
    path: "/",
    linkComponent: "a",
  },
  myaccount: {
    path: "/sections/prophoto/myaccount.php",
    protected: true,
    linkComponent: "a",
  },
  "products.list": {
    path: "/sections/products2.php",
    protected: true,
    linkComponent: "a",
  },
  privacypolicy: {
    path: "/privacy-policy",
    linkComponent: "a",
  },
  cookiesdescription: {
    path: "/sections/webshop/cookiesdescription.php",
    linkComponent: "a",
  },
  shoppingcart: {
    path: "/sections/shopping-cart/",
    protected: true,
    linkComponent: "a",
  },
  checkout: {
    path: "/sections/shopping-cart/checkout/",
    protected: true,
    linkComponent: "a",
  },
  "products.digitalportraits.subject": {
    path: "/sections/digital-portraits/:subjectUuid/",
    protected: true,
    linkComponent: "a",
  },
  "products.cards": {
    path: "/sections/cardscalendars/cardsv2/",
    protected: true,
    linkComponent: "a",
  },
  "products.calendars": {
    path: "/sections/cardscalendars/calendarsv2/",
    protected: true,
    linkComponent: "a",
  },
  "products.categories.category.create": {
    path: "/sections/cardscalendars/create_product.php?template=:templateUuid&medium=:productUuid&promoted",
    protected: true,
    linkComponent: "a",
  },
  "products.calendars.create": {
    path: "/sections/cardscalendars/create_product.php?template=:templateUuid&medium=:productUuid&promoted",
    protected: true,
    linkComponent: "a",
  },
  "products.photogifts.category": {
    path: "/sections/cardscalendars/photogifts/displaycategory.php?category=:category",
    protected: true,
    linkComponent: "a",
  },
  "products.packages": {
    path: "/sections/packages/",
    protected: true,
    linkComponent: "a",
  },
  "products.digitalportraits": {
    path: "/sections/digital-portraits/",
    protected: true,
    linkComponent: "a",
  },
  "products.catalogues": {
    path: "/sections/products.php?open_catalogue_dialog=1",
    protected: true,
    linkComponent: "a",
  },
  "products.cards.category": {
    path: "/sections/cardscalendars/cardsv2/?category=:category",
    linkComponent: "a",
    protected: true,
  },
  "pictureset.download.file": {
    path: "/sections/prophoto/ajax/digitalcopies.php?dl=file&file=:uuid",
    protected: true,
    linkComponent: "a",
  },
  "pictureset.download.file.background": {
    path: "/sections/prophoto/ajax/digitalcopies.php?dl=file&file=:uuid&background=:background",
    protected: true,
    linkComponent: "a",
  },
};

// We add this as a hook so we can implement localization later:
const useDesktopRoutes = () => {
  return Routes;
};

export default useDesktopRoutes;
